import AOS from "aos";
import "aos/dist/aos.css";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "./components";
import { LanguageContextProvider } from "./context";
import "./index.css";

// import "tw-elements";
import { HelmetProvider } from "react-helmet-async";
import { restoreAuthSession } from "./redux/actions/authActions";
import configStore from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import router from "./routes";
import AppErrorBoundary from "./components/common/AppErrorBoundary";

AOS.init();

const store = configStore();
store.dispatch(restoreAuthSession());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <LanguageContextProvider>
          <Suspense fallback={<Loader />}>
            <AppErrorBoundary>
              <RouterProvider router={router} />
            </AppErrorBoundary>
          </Suspense>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </LanguageContextProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
